
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeThreeway as ObiPipeThreewayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-threeway.js';
 
 
 

 
 export const ObiPipeThreeway = createComponent({
   react: React,
   tagName: 'obi-pipe-threeway',
   elementClass: ObiPipeThreewayElement,
   events: {
     
   }
  });
 
 